import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	accessToken: undefined,
	roleId: undefined,
	userId: undefined,
	refreshToken: undefined,
	roleName: undefined,
};

const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		userLoggedIn(state, action) {
			state.accessToken = action.payload.accessToken;
			state.roleId = action.payload.roleId;
			state.userId = action.payload.userId;
			state.refreshToken = action.payload?.refreshToken;
			state.roleName = action.payload?.roleName;
		},
		userLoggedOut(state) {
			state.accessToken = undefined;
			state.roleId = undefined;
			state.userId = undefined;
			state.refreshToken = undefined;
			state.roleName = undefined;
		},
	},
});

export const { userLoggedIn, userLoggedOut } = authSlice.actions;
export default authSlice.reducer;
